import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';
import SubscriptionsApi from '../services/api/subscription.js';

export default {
    mixins: [pageLoadingStatusMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            subscriptionType: null
        };
    },
    computed: {
        ...mapGetters({
            subscriptions: 'subscriptions/items'
        })
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getSubscriptions();
    },
    methods: {
        /**
         * Get the subscriptions.
         */
        getSubscriptions() {
            SubscriptionsApi.get().then(this.finishLoading);
        }
    }
};
